module.exports = __webpack_public_path__ + "static/media/SoccerBkgSplash.2559b871.png";